import { useEffect, useState } from "react";
import { Link, useLocation, useMatch, useResolvedPath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classes from './Navigation.module.css';
import navItems from './navList';
import { arrow, arrowDown } from "../../assets";

const Navigation = ({ isMenuOpen }) => {
  const user = useSelector(state => state.user);
        
  return (
    <nav className={`${classes.nav} ${!isMenuOpen ? classes.collapsed : ''}`}>
      <ul>
        {
          navItems.map(navItem => {
            if (
              user && user.type &&
              (user.type.toLowerCase() === 'user' || user.type.toLowerCase() === 'admin') &&
              navItem.to === '/users'
            ) {
              return null;
            }
            if (navItem.children && navItem.children.length > 0) {
              return <CustomLink key={navItem.to} to={navItem.to} subnav={navItem.children} isMenuOpen={isMenuOpen} icon={navItem.icon}>{navItem.label}</CustomLink>;
            } else {
              return <CustomLink key={navItem.to} to={navItem.to} isMenuOpen={isMenuOpen} icon={navItem.icon}>{navItem.label}</CustomLink>;
            }
          })
        }
      </ul>
    </nav>
  )
};

export default Navigation;

const CustomLink = ({ to, children, isMenuOpen, icon, ...props }) => {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname });
  const location = useLocation();
  const [toggle, setToggle] = useState(false);
  const [manualToggle, setManualToggle] = useState(false);
     
  let isChildActive = false;
  if (!isChildActive && location.pathname.startsWith(to)) {
    isChildActive = true;
  }
   
  useEffect(() => {
    if (isActive || isChildActive) {
      setToggle(true);
    } else if (!manualToggle) {
      setToggle(false);
    }
  }, [location, isActive, isChildActive, manualToggle]);
   
  const toggleMenu = () => {
    setManualToggle(true);
    setToggle(!toggle);
  };
   
  return (
    <li className={`${isActive || isChildActive ? classes.active : ''} ${toggle ? classes.active : ''}`}>
      <Link to={to} {...props} title={!isMenuOpen ? children : ''}>
        {!isMenuOpen && icon && <span className={classes.icon}>{icon}</span>}
        {isMenuOpen && children}
      </Link>
      {props.subnav && props.subnav.length > 0 && isMenuOpen && (
        <ul style={{ display: toggle ? 'block' : 'none' }}>
          {props.subnav.map(subnavItem => (
            <CustomSubLink key={subnavItem.to} to={subnavItem.to} icon={subnavItem.icon}>
              {subnavItem.label}
            </CustomSubLink>
          ))}
        </ul>
      )}
      {props.subnav && props.subnav.length > 0 && isMenuOpen && (
        <span onClick={toggleMenu} className="nav-arrow" style={{ cursor: 'pointer' }}>
          {toggle ? <img src={arrowDown} alt="" /> : <img src={arrow} alt="" />}
        </span>
      )}
    </li>
  )
};

const CustomSubLink = ({ to, children, icon, ...props }) => {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, startsWith: true });
  const location = useLocation();
  let isChildActive = false;
  if (!isChildActive && location.pathname.startsWith(to)) {
    isChildActive = true;
  }
   
  return (
    <li key={to} className={isActive || isChildActive ? classes.active : ''}>
      <Link to={to} {...props}>{children}</Link>
    </li>
  )
};